import { Notification, ButtonToolbar } from "rsuite";
import Button from "../LogButton/Button";

export const customAlert = async (Type, Title, Message) => {
  Notification[Type]({
    title: Title,
    description: (
      <p style={{ width: 200, height: "auto" }}>{Message ? Message : null}</p>
    ),
    duration: 5000,
    placement: "topRight",
  });
};

export const ConfirmLogout = (history) => {
  console.log(history);
  const locationData = {
    pathname: "/",
    state: { fromDashboard: true },
  };
  Notification["warning"]({
    title: "Logout",
    duration: 10000,
    description: (
      <div>
        <p style={{ width: 200, height: 30 }}>
          <strong>Are You Sure?</strong>{" "}
        </p>
        <ButtonToolbar>
          <Button
            onClick={function () {
              Notification.close();
              history.replace(locationData);
              sessionStorage.clear();
              window.location.reload();
            }}
          >
            Logout
          </Button>
          <Button
            onClick={() => {
              Notification.close();
            }}
          >
            Cancel
          </Button>
        </ButtonToolbar>
      </div>
    ),
    placement: "topLeft",
  });
};
